import { useCallback, useEffect, useMemo, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import NotificationService from "services/notification";

const service = new NotificationService();

const useComponent = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [mobileFilter, setMobileFilter] = useState("all");

  const isInboxOnly = searchParams.get("view") === "inbox";

  const unreadCount = useMemo(() => {
    return (items || []).filter((item) => !item?.read_on).length;
  }, [items]);

  const mobileItems = useMemo(() => {
    if (mobileFilter === "all") {
      return items;
    }
    return (items || []).filter((item) => !item?.read_on);
  }, [items, mobileFilter]);

  const formatTime = useCallback((value) => {
    if (!value) {
      return "";
    }
    return new Date(value).toLocaleString("vi-VN");
  }, []);

  const loadData = useCallback(async () => {
    setLoading(true);
    try {
      const rows = await service.list({ page: 1, page_size: 100 });
      setItems(rows || []);
    } catch (_) {
      setItems([]);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    loadData();
  }, [loadData]);

  const onReadAll = useCallback(async () => {
    setSubmitting(true);
    try {
      await service.readAll();
      await loadData();
    } finally {
      setSubmitting(false);
    }
  }, [loadData]);

  const onItemClick = useCallback(async (item) => {
    if (!item?.read_on) {
      await service.read({ id: item.id });
    }

    if (item?.action_url) {
      navigate(item.action_url);
      return;
    }

    await loadData();
  }, [loadData, navigate]);

  const goSettings = useCallback(() => {
    navigate("/notifications/settings");
  }, [navigate]);

  return {
    items,
    loading,
    submitting,
    mobileFilter,
    setMobileFilter,
    isInboxOnly,
    unreadCount,
    mobileItems,
    loadData,
    onReadAll,
    onItemClick,
    goSettings,
    formatTime,
  };
};

export default useComponent;
